import classNames, { type Argument } from 'classnames'

/**
 * Thin wrapper over `classnames` so callers import from a single place.
 * Kept in lib/ (pure, no React) — safe to import from anywhere.
 */
export function cn(...args: Argument[]): string {
  return classNames(...args)
}
